import React, { Component } from 'react';
import { FormSpy } from 'react-final-form';

export default function withFormProps(WrappedComponent) {
    return class FormProps extends Component {
        render() {
            return (
                <FormSpy subscription={{ form: true }}>
                    { (formProps) => (
                        <WrappedComponent
                            {...this.props}
                            {...formProps}
                        />
                    )}
                </FormSpy>
            );
        }
    }
}
